import { Text } from '@rbilabs/universal-components';

import { getDesignToken } from 'styles/constants';
const BaseInputMessageText = Text.withConfig(() => ({
  paddingTop: '2',
  textAlign: 'left',
}));

export const InputMessageText = BaseInputMessageText.withConfig<{
  $hasError?: boolean;
  $disabled?: boolean;
}>(({ $hasError, $disabled }) => {
  if ($disabled) {
    return { color: getDesignToken('text-disabled') };
  }
  if ($hasError) {
    return { color: getDesignToken('text-error') };
  }
  return { color: getDesignToken('text-default') };
});
